import React, { useEffect, useState } from 'react'
import RadioButtonList from './RadioButtonList'
import { Container, Row, Col, Accordion , Navbar, Offcanvas, Nav,Form  } from 'react-bootstrap'
import CheckBoxList from './CheckBoxList';
import { get_crimes } from '../api'
import FormLocation from './FormLocation';

function SearchAdvanced({
  children
}) {

  return (
    <Navbar collapseOnSelect expand="md" className="bg-body-tertiary">
      <Container fluid className='p-1'>
        
      <Navbar.Toggle aria-controls="navbarSearchAdvanced" />
        
      <Navbar.Offcanvas id="navbarSearchAdvanced">

        {/* <Offcanvas.Header> Búsqueda avanzada </Offcanvas.Header> */}
        <Offcanvas.Body>

          <Nav className="me-auto" navbarScroll style={{width:"100%"}}>
            <Container fluid >
              <Row>
                <Col>
                  { children }
                </Col>
              </Row>
            </Container>
          </Nav>
        </Offcanvas.Body>
      </Navbar.Offcanvas>

      </Container>     
    </Navbar>
  )
}

export default SearchAdvanced